import {Ref} from "vue";
import {
    BasketItem,
    DeliveryCalculate,
    Modificator,
    ModificatorOption,
    OrderAttributesValue,
    OrderProfile,
    OrderProfileAttributesValue
} from "@/gql/gen";
import {ProductModel} from "@/modules/shop/composable/useProduct";
import {BasketItemCalculation} from "@/modules/shop/store/util/benefit";
import {ProductModificatorDescriptor} from "@/modules/shop/store/util/catalog";
import {BasketItemError, BasketItemStatus} from "@/modules/shop/store/util/basket";
import {OrderProfilePayload} from "@/modules/shop/store/util/order-profile";
import {GeoCoordinates} from "@/modules/geo/class/GeoCoordinates";
import {Maybe} from "@/core/types";

export function getOrderAttrsCoords(attrs: Attrs) {
    if (attrs.HOUSE_COORDS && attrs.HOUSE_COORDS.LAT && attrs.HOUSE_COORDS.LON) {
        return [attrs.HOUSE_COORDS.LAT, attrs.HOUSE_COORDS.LON]
    }
}

export function getOrderAttrsAddress(attrs: Attrs) {
    return attrs.ADDRESS
}

export type ReactiveBasketItemModel = BasketItemModel

export interface BasketItemModel {
    _isModel: boolean
    id: number
    parentId: number
    fields: BasketItem
    product: ProductModel
    children: Ref<BasketItemModel[]>
    isRoot: Ref<boolean>
    state: {
        clientChangedAt: number,
        needSync: boolean
    }
    setParent: (parent: BasketItemModel) => void
    setQuantity: (quantity: number, options?: { silent?: boolean }) => void,
    addQuantity: (quantity: number) => void,
    remove: () => void,
    setGift: (productId: number) => void
    getPrice: () => number
    getPriceTotal: () => number
    markChanged: () => void
    updateFromServer: (data: any) => void
    getFakeSync: () => any
    setCommitted: () => void
    commited: Ref<boolean>
    calc: Ref<BasketItemCalculation>,
    setIngredientState: (elementId: number, state?: boolean) => void,
    setModificatorValue: (modificator: ProductModificatorDescriptor, value: any) => void,
    getModificatorValue: (modificator: ProductModificatorDescriptor) => any,
    syncChildren: () => void,
    selectedModificators: Ref<ProductModificatorsSelected>
    status: Ref<BasketItemStatus>
    errors: Ref<BasketItemError[]>
    getApiData: () => any
    getUuid: () => string
    getIsAddedByModificator: () => boolean | null | undefined
    getIsChild: () => boolean
    getIsRoot: () => boolean
    getParentUuid: () => string | null;
    getParentItem: () => BasketItemModel | null | undefined;
    isEqualWithItem: (compareItem: BasketItemModel) => boolean;
    getReasonModificatorId: () => number | null | undefined;
    getReasonModificatorCode: () => string | null | undefined;
    getReasonModificator: () => Modificator | null | undefined;
    getReasonRuleId: () => (number | null | undefined);
    isGift: Ref<boolean>
}

export type ProductModificatorSelectedOption = {
    option: ModificatorOption,
    valueQuantity: number
}

export type ProductModificatorSelected = {
    mod: Modificator,
    value: Record<string, number>,
    valueOptions: Record<string, ProductModificatorSelectedOption>
}

export type ProductModificatorsSelected = Record<string, ProductModificatorSelected>


type Attrs = OrderAttributesValue | OrderProfileAttributesValue

export type OrderProfileModel = {
    id: Ref<Maybe<number>>,
    getId: () => number | null,
    address: Ref<Maybe<string>>,
    addressHash: Ref<string | null>,
    name: Ref<string | null>,
    caption: Ref<string>,
    source: OrderProfile,
    payload?: OrderProfilePayload,
    coords: Ref<GeoCoordinates | null>,
    setAttrs: (attrs: Partial<OrderProfileAttributesValue>) => void,
    beforeSave: () => void,
    getRawAttrValues: () => OrderProfileAttributesValue,
    deliveryTimeMinutes: Ref<number | null>,
    textInputFields: Ref<any>,
    navCoords: Ref<GeoCoordinates | null>,
    deliveryCalculateNearest: any,
    deliveryCalculateResult: Ref<Maybe<DeliveryCalculate>>,
    updateSource: (source: OrderProfile) => void,
    clone: () => OrderProfileModel,
}



